import BaseService from "./base.service";
import UserDebtInterface from "@homegame/common/dist/interface/user-debt.interface";
import UserDebtFilterInterface from "@homegame/common/dist/interface/filters/user-debt-filter.interface";
import AccumulatedDebtInterface from "@homegame/common/dist/interface/accumulated-debt.interface";
import TransactionInterface from "@homegame/common/dist/interface/transaction.interface";
import { DebtHistory } from "../../transactions/components/debt-item.component";
import TransactionStatus from "@homegame/common/dist/enum/transaction-status.enum";

export default class UserDebtsService extends BaseService {
  baseEndpoint = "user-debts";

  async list(
    params?: UserDebtFilterInterface,
  ): Promise<[AccumulatedDebtInterface[], number]> {
    return this.request<[any[], number]>({
      method: "get",
      url: `${this.baseEndpoint}/find-by-game`,
      params,
      transformResponse: [this.baseTransformResponse],
    });
  }

  async payTableDebt(params?: {
    fromUserId: number;
    tableId: number;
    toUserId: number;
    amount: number;
  }): Promise<[UserDebtInterface[], number]> {
    return this.request({
      method: "post",
      url: `${this.baseEndpoint}/pay-table-debt`,
      data: params,
    });
  }

  async assignDebt(
    debtsAssigned: Partial<TransactionInterface>,
  ): Promise<[TransactionInterface[], number]> {
    return this.request({
      method: "post",
      url: `${this.baseEndpoint}/assign-debt`,
      data: { ...debtsAssigned, status: TransactionStatus.PENDING },
    });
  }

  async reAssignDebt(id: number): Promise<[TransactionInterface[], number]> {
    return this.request({
      method: "put",
      url: `${this.baseEndpoint}/${id}/reassign`,
    });
  }

  async userDebts(params?: {
    fromUserId: number;
    toUserId: number;
    tableId: number;
    take: number;
    skip: number;
  }): Promise<TransactionInterface[]> {
    return this.request({
      method: "get",
      url: `${this.baseEndpoint}/history`,
      params,
      transformResponse: [this.baseTransformResponse],
    });
  }

  async getTestHistory(params?: {
    fromUserId: number;
    toUserId: number;
    tableId: number;
    take: number;
    skip: number;
  }): Promise<[DebtHistory[], number]> {
    return this.request({
      method: "get",
      url: `${this.baseEndpoint}/history2`,
      params,
      transformResponse: [this.baseTransformResponse],
    });
  }

  async approveTableDebt(params?: {
    fromUserId: number;
    tableId: number;
    toUserId: number;
    amount: number;
  }): Promise<[UserDebtInterface[], number]> {
    return this.request({
      method: "post",
      url: `${this.baseEndpoint}/approve-table-debt`,
      data: params,
    });
  }

  async declineTableDebt(params?: {
    fromUserId: number;
    tableId: number;
    toUserId: number;
    amount: number;
  }): Promise<[UserDebtInterface[], number]> {
    return this.request({
      method: "post",
      url: `${this.baseEndpoint}/decline-table-debt`,
      data: params,
    });
  }
}
